import React from 'react'
import { templatesQueries, useTemplateStepsContext } from '@/features/templates'
import { useFormikContext } from 'formik'
import Button from '@/components/ui/Buttons/Button'
import Typography from '@/components/ui/Typography'
import { LoadingButton } from '@/components/ui/Buttons/LoadingButton'
import { useSuspenseQuery } from '@tanstack/react-query'

export type SummaryStepProps = {
  templateId: number
}

export const SummaryStep = ({ templateId }: SummaryStepProps) => {
  const {
    data: { template },
  } = useSuspenseQuery(templatesQueries.detail(templateId))
  const { currentStep, setCurrentStep } = useTemplateStepsContext()
  const { errors, isSubmitting, submitForm } = useFormikContext()

  return (
    <div style={{ width: 480 }}>
      <Typography variant={'xxl'}>Activate {template.name} Now</Typography>
      <Typography>
        You are just one step away to from activating {template.name}. Did you know that Knots Studio can do way more
        than that? This template is just one {"'route'"} and you can create many more. If you need a custom solution,
        reach out any time. We are happy to help.
      </Typography>
      <div className={'d-flex justify-content-between mt-4'}>
        {currentStep > 0 && (
          <Button color={'neutral'} onClick={() => setCurrentStep(currentStep - 1)}>
            Back
          </Button>
        )}
        <LoadingButton disabled={Object.keys(errors).length !== 0} isLoading={isSubmitting} onClick={submitForm}>
          Get started
        </LoadingButton>
      </div>
    </div>
  )
}
